import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import {
  Publisher,
  UserProfile,
} from '../../customRoutes/authentication/types';
import { getUserProfile } from '../../dataProvider/dataProvider';

export const usePublisherData = () => {
  const {
    data: userProfile,
    isLoading,
    error,
  } = useQuery<UserProfile>({
    queryKey: ['user-profile'],
    queryFn: () =>
      getUserProfile().then(profile => profile || { message: 'no-profile' }),
    // Profile is session-stable — cache indefinitely to avoid loading flashes
    // when PublisherLayout remounts on navigation.
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const publishers = useMemo<Publisher[]>(() => {
    return userProfile?.publishers || [];
  }, [userProfile?.publishers]);

  return { publishers, isLoading, error };
};
